window.Vue = require('vue');

Vue.component('alf-story-progress-bar', require('./components/stories/progress-bar.vue'));

const app = new Vue({
    el: '#progress-bar'

});


// WEBPACK FOOTER //
// ./resources/assets/js/site/story-progress-bar.js